import { Typography } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import { Avatar, Select } from 'components/common';
import { SelectProps } from 'components/common/select/Select';
import { useUsersOptions } from 'hooks';
import { useMemo } from 'react';
import { FindAllUserOptionDto, UserCompactDto } from 'types';
import { ITEM_SELECT_ALL, removeSpecialCharacters } from 'utils';

type SelectUsersProps = SelectProps &
  Omit<FindAllUserOptionDto, 'keyword' | 'pageIndex' | 'pageSize'> & {
    isAll?: boolean;
    allItemLabel?: string;
    selectedOpts?: UserCompactDto[];
    valueField?: keyof UserCompactDto;
    renderExtension?: boolean;
  };

const SelectUsers = ({
  organizationUnitId,
  isAll = false,
  allItemLabel,
  selectedOpts = [],
  valueField = 'userId',
  renderExtension,
  ...props
}: SelectUsersProps) => {
  const {
    usersOptions: users,
    isLoading,
    isFetching
  } = useUsersOptions(
    {
      // keyword,
      organizationUnitId,
      isLoadAll: true
    },
    {
      refetchOnMountOrArgChange: true
    }
  );

  const normalize = (str: string) => removeSpecialCharacters(str).toLowerCase();

  const usersOptions = useMemo(() => {
    let options = renderExtension ? users.filter((user) => user.extensionId) : users;
    if (selectedOpts && selectedOpts.length > 0) {
      options = users.filter((user) => {
        return !selectedOpts.some((selected) => selected.userId === user.userId);
      });
    }
    return options;
  }, [users, selectedOpts]);

  return (
    <Select
      {...props}
      loading={isLoading || isFetching}
      showSearch
      filterOption={(input, option) => {
        let label = option?.title || '';
        if(renderExtension){
          label += ` ${option?.extensionId || ''}`;
        }
        // const label = renderExtension ? option?.extensionId : option?.title;
        const labelStr = typeof label === 'string' ? label : String(label ?? '');
        return normalize(labelStr).includes(normalize(input));
      }}
      labelRender={(option: DefaultOptionType) => <div>{option.title}</div>}
      options={[
        ...(isAll
          ? [
              {
                ...ITEM_SELECT_ALL,
                title: allItemLabel ?? ITEM_SELECT_ALL.title,
                label: allItemLabel ?? ITEM_SELECT_ALL.title
              }
            ]
          : []),
        ...(usersOptions.map((itm) => ({
          ...itm,
          title: itm.fullName,
          label: (
            <div className='flex items-center gap-2'>
              <Avatar size={24} name={itm.fullName} fileId={itm.avatar} />
              <div className='grow'>
                <Typography.Text>{itm.fullName}</Typography.Text>
                {renderExtension ? (
                  <div>
                    <Typography.Text
                      ellipsis={{ tooltip: true }}
                      className='max-w-[320px] overflow-hidden text-ellipsis whitespace-nowrap text-sm text-subTextColor'
                    >
                      Ext. {itm.extensionId}
                    </Typography.Text>
                  </div>
                ) : (
                  <div className='flex w-full items-center justify-between gap-8'>
                    <Typography.Text className='shrink-0 text-sm text-subTextColor'>{itm.username}</Typography.Text>
                    <Typography.Text
                      ellipsis={{ tooltip: true }}
                      className='max-w-[320px] overflow-hidden text-ellipsis whitespace-nowrap text-sm text-subTextColor'
                    >
                      {itm.organizationUnitName}
                    </Typography.Text>
                  </div>
                )}
              </div>
            </div>
          ),
          value: itm[valueField] as string | number,
          key: itm['userId']
        })) || [])
      ]}
      // onDropdownVisibleChange={(open) => {
      //   if (open) {
      //     handleSearch('');
      //   }
      // }}
    />
  );
};
export default SelectUsers;
